import Sidebar from "../components/Sidebar";

const jobs = [
  { id: "TMP-0041", client: "BuildCorp Pty Ltd", type: "TMP", status: "In Progress", date: "Apr 6, 2026", location: "Sydney, NSW" },
  { id: "TGS-0039", client: "Metro Roads Inc", type: "TGS", status: "Completed", date: "Apr 4, 2026", location: "Melbourne, VIC" },
  { id: "TMP-0038", client: "Sunrise Developments", type: "TMP", status: "In Review", date: "Apr 3, 2026", location: "Brisbane, QLD" },
  { id: "TC-0037", client: "CityWorks Council", type: "TC", status: "Completed", date: "Apr 1, 2026", location: "Perth, WA" },
  { id: "TGS-0036", client: "Apex Constructions", type: "TGS", status: "In Progress", date: "Mar 30, 2026", location: "Adelaide, SA" },
  { id: "TMP-0035", client: "Horizon Builders", type: "TMP", status: "Completed", date: "Mar 28, 2026", location: "Hobart, TAS" },
  { id: "TC-0034", client: "RoadSafe Group", type: "TC", status: "Completed", date: "Mar 25, 2026", location: "Darwin, NT" },
];

const statusColors = {
  "In Progress": "bg-orange-100 text-orange-600",
  Completed: "bg-green-100 text-green-600",
  "In Review": "bg-blue-100 text-blue-600",
};

export default function Jobs() {
  return (
    <div className="flex">
      <Sidebar />
      <main className="flex-1 bg-gray-50 min-h-[calc(100vh-4rem)]">
        <div className="p-6 md:p-8 max-w-6xl">
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-black">
              Jobs / Requests
            </h1>
            <p className="text-gray-500 mt-1">
              View and manage all your traffic planning jobs.
            </p>
          </div>

          <div className="bg-white rounded-xl border border-gray-200">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                    <th className="px-6 py-3">Job ID</th>
                    <th className="px-6 py-3">Client</th>
                    <th className="px-6 py-3">Type</th>
                    <th className="px-6 py-3">Location</th>
                    <th className="px-6 py-3">Status</th>
                    <th className="px-6 py-3">Date</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {jobs.map((job) => (
                    <tr key={job.id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 text-sm font-medium text-black">{job.id}</td>
                      <td className="px-6 py-4 text-sm text-gray-600">{job.client}</td>
                      <td className="px-6 py-4">
                        <span className="text-xs font-medium bg-gray-100 text-gray-600 px-2.5 py-1 rounded-full">{job.type}</span>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">{job.location}</td>
                      <td className="px-6 py-4">
                        <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${statusColors[job.status]}`}>{job.status}</span>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">{job.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
